import i18next from 'i18next';

import { LOCALE_ES, initI18next } from '@growtherapy/i18n';
import { NS_SPROUT_CORE } from '@growtherapy/sprout-ui';

import { NS_SEEDLINGS_CORE } from '@grow-therapy-team/seedling-components';

import { NS_TELEHEALTH_CORE, telehealthCoreResoucesEn } from '.';
import { logger } from '../datadog/logger';
import { getStoredLanguagePreference } from './languagePreference';

export const CROWDIN_DISTRIBUTION_HASH = 'e-55b8f1847490f0b920ba3b3mgk';

// TODO: When adding a new locale here, also add:
// 1. New i18n keys in telehealth-core.json (e.g. switchYourLanguageToFrench, yourBrowserIsSetToFrench, switchToFrench)
// 2. A new case in getPromptContent() in BrowserLanguagePrompt.tsx
export const ADDITIONAL_SUPPORTED_LOCALES = [LOCALE_ES];

export const initI18n = (): void => {
  initI18next(i18next, {
    lng: getStoredLanguagePreference(),
    ns: [NS_TELEHEALTH_CORE, NS_SPROUT_CORE, NS_SEEDLINGS_CORE],
    defaultNS: [NS_TELEHEALTH_CORE, NS_SPROUT_CORE, NS_SEEDLINGS_CORE],
    resources: telehealthCoreResoucesEn,
    additionalSupportedLngs: ADDITIONAL_SUPPORTED_LOCALES,
    otaOptions: {
      distributionHash: CROWDIN_DISTRIBUTION_HASH,
      otaLanguages: ADDITIONAL_SUPPORTED_LOCALES,
    },
    missingKeyHandler: (lngs, ns, key) => {
      logger.error(`[i18n] Missing translation key: ${key} ns: ${ns} lng: ${lngs} service: telehealth`);
    },
  });
};
